// extracted by mini-css-extract-plugin
export var dark = "ContactCard-module--dark--VzpOe";
export var quote = "ContactCard-module--quote--f6B2E";
export var wrapper = "ContactCard-module--wrapper--SPETW";